<template>
    <div class="add-item-container">
        <b-dropdown aria-role="list">
            <a slot="trigger" role="button" class="button">
                <b-icon icon="sticker-plus-outline" size="is-small"></b-icon>
                <span>{{ $t('interface.createNewObject') }}</span>
                <b-icon icon="chevron-down" size="is-small"></b-icon>
            </a>
            <b-dropdown-item v-if="isDocflowManager" @click.native="routeTo('createIncomingDocflow')">
                <b-icon icon="clipboard-arrow-down-outline" size="is-small" class="mr-5"></b-icon>
                <span>{{ $t('docflow.fullDocTypes.incoming') }}</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="isDocflowOutgoingManager" @click.native="routeTo('createOutgoingDocflow')">
                <b-icon icon="clipboard-arrow-up-outline" size="is-small" class="mr-5"></b-icon>
                <span>{{ $t('docflow.fullDocTypes.outgoing') }}</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="isDocflowAppealManager" @click.native="routeTo('createAppealDocflow')">
                <b-icon icon="clipboard-account-outline" size="is-small" class="mr-5"></b-icon>
                <span>{{ $t('routes.docflowAppeals') }}</span>
            </b-dropdown-item>
            <b-dropdown-item @click.native="routeTo('createDocument')">
                <b-icon icon="account-tie-outline" size="is-small" class="mr-5"></b-icon>
                <span>{{ $t('docflow.workflow.title') }}</span>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        methods: {
          routeTo(name) {
              this.$router.push({name})
          }
        },
        computed: {
            ...mapGetters('Account', ['isDocflowManager', 'isDocflowOutgoingManager', 'isDocflowAppealManager']),
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/variables";

    .add-item-container {
        vertical-align: top;
        height: $header-height;
        display: inline-block;
        padding-top: 18px;

        .button {
            color: #6F6F6F;
        }
    }
</style>
